"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TitleBar = void 0;
var react_1 = __importDefault(require("react"));
require("./index.less");
/**
 * 滚动标题栏
 * @returns
 */
function TitleBar(props) {
    var style = {};
    if (props.mt != undefined) {
        style.marginTop = props.mt + 'px';
    }
    return (react_1.default.createElement("div", { className: "titlebar", style: style }, props.children));
}
exports.TitleBar = TitleBar;
TitleBar.Title = function (props) {
    return (react_1.default.createElement("div", { className: "title" }, props.children));
};
TitleBar.Content = function (props) {
    return (react_1.default.createElement("div", { className: "content" }, props.children));
};
